import useFetch from './useFetch.ts';
import { useCallback } from 'react';
export const useGetLoginCodeRequest = function () {
    const fetcher = useFetch();
    return useCallback(function (email, hToken) {
        return fetcher(`/api/user/get_login_code`, {
            method: 'POST',
            body: JSON.stringify({
                email,
                hToken,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }, [fetcher]);
};
